export default __webpack_public_path__ + "static/media/plus.aa924a0d.svg";